import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "A method for estimating the Thiele and Small parameters of an electrodynamic loudspeaker is presented below. Navigate with the arrows to discover it!",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 2,
      rows: 3,
      colsSize: [1.1, 1],
      rowsSize: [1, 3, 1],
      colSpan: {
        "0:0": 2,
      },
      rowSpan: {
        "1:1": 2,
      },
      gap: "0 7%",
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "Impedance and results",
                  scrollbars: false,
                  formatter: "html",
                  styles: {
                    fontSize: "14px",
                    lineHeight: "22px",
                    fontWeight: 800,
                    letterSpacing: "0.25em",
                    textTransform: "uppercase",
                  },
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/04/19/principle/slide-8.svg`,
                },
              },
              styles: {
                paddingBottom: "10%",
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: `<ol>
                  <li>We have M<sub>a</sub> = 181 g
                  <li>The impedance curve gives:</br>f<sub>s</sub> = 20.8 Hz and</br>f<sub>sm</sub> = 14.0 Hz
                  <li>Manufacturer gives S<sub>d</sub> = 350 cm<sup>2</sup>
                  <li>Then, V<sub>as</sub> =</br>
                  <math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
                  <mfrac>
                  <mrow> <mn>1.2</mn> <mspace width="5px"/> <mo>x</mo> <mspace width="5px"/> <msup> <mn>34.3</mn> <mn>2</mn> </msup> <mspace width="5px"/> <mo>x</mo> <mspace width="5px"/> <msup> <mn>0.0352</mn> <mn>2</mn> </msup> </mrow>
                  <mrow> <mn>4</mn> <msup> <mi>π</mi> <mn>2</mn> </msup> <mspace width="5px"/> <mo>x</mo> <mspace width="5px"/> <mn>0.181</mn> </mrow>
                  </mfrac>
                  </math></br>
                  <math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
                  <mo>(</mo>
                  <mfrac>
                  <mrow> <mn>1</mn> </mrow>
                  <mrow>  <msup> <mn>14</mn> <mn>2</mn> </msup> </mrow>
                  </mfrac>
                  <mo>-</mo>
                  <mfrac>
                  <mrow> <mn>1</mn> </mrow>
                  <mrow>  <msup> <mn>20.8</mn> <mn>2</mn> </msup> </mrow>
                  </mfrac>
                  <mo>)</mo>
                  <mo>=</mo>
                  <mn>67.1</mn>
                  <mspace width="5px"/>
                  <mi>l</mi>
                  </math>
                  </ol>`,
                  scrollbars: false,
                  formatter: "html",
                  styles: {
                    fontSize: "14px",
                    lineHeight: "20px",
                    fontWeight: 400,
                  },
                },
              },
              styles: {
                alignItems: "flex-start",
              },
            },
          },
        ],
        [],
      ],
    },
  },
};

export default principle;
